import type { TourStep } from '../ui/tour';

/**
 * قدم‌های تورِ «جدول عملکرد ماهانه ارزیابی».
 * انتخاب‌گرها به attributeهای data-tour در EvaluationGrowthTable و دکمه‌ی راهنما متصل‌اند.
 * در سطحِ ماژول ثابت تعریف شده تا identity پایدار بماند (لازمِ useDashboardTour).
 */
export const EVALUATION_GROWTH_TOUR: TourStep[] = [
  {
    title: '👋 به راهنمای تعاملی خوش آمدید',
    description:
      'در چند قدم کوتاه، طرز کار این جدول و معنی هر بخش را روی خودِ صفحه نشان می‌دهیم. با دکمه‌ی «بعدی» جلو بروید.',
  },
  {
    element: '[data-tour="eval-table"]',
    title: 'جدول عملکرد ماهانه',
    description:
      'هر <b>سطر</b> یک ماه است و هر <b>ستون</b> یک شاخصِ ارزیابی. واحد هر شاخص (درصد یا تعداد) کنار عنوان آن مشخص شده است.',
    side: 'top',
    align: 'center',
  },
  {
    element: '[data-tour="eval-sort"]',
    title: 'مرتب‌سازی ستون',
    description:
      'با این دکمه جدول را بر اساس همین ستون مرتب می‌کنید. کلیک اول: نزولی (بیشترین به کمترین)، کلیک دوم: صعودی. فلش، جهت فعلی را نشان می‌دهد.',
    side: 'bottom',
    align: 'center',
  },
  {
    element: '[data-tour="eval-chart"]',
    title: 'نمایش نمودار ستون',
    description:
      'این دکمه نمودار همان شاخص را در پایین جدول باز می‌کند و روند شعبه را با گروه برند مقایسه می‌کند. شاخص‌های درصدی میله‌ای و تعدادی خطی رسم می‌شوند.',
    side: 'bottom',
    align: 'center',
  },
  {
    element: '[data-tour="eval-growth"]',
    title: 'نشان رشد (نسبت به ماه قبل)',
    description:
      'زیر چهار شاخص کلیدی، تغییر نسبت به ماه قبل نمایش داده می‌شود: <b>سبز ↗</b> یعنی رشد و <b>قرمز ↘</b> یعنی کاهش. موس را روی آن نگه دارید تا مقدار دقیق را ببینید.',
    side: 'left',
    align: 'center',
  },
  {
    element: '[data-tour="eval-guide-btn"]',
    title: 'راهنمای کامل',
    description:
      'برای توضیح خط‌به‌خطِ همه‌ی ستون‌ها و جزئیات بیشتر، هر زمان روی این دکمه بزنید. تور تمام شد ✅',
    side: 'bottom',
    align: 'center',
    centerOnScroll: true,
  },
];
